import RefreshDoubleIcon from '@/assets/refresh-double2.svg?react';
import CheckCircleIcon from '@/assets/check-circle.svg?react';
import WarningTriangleIcon from '@/assets/warning-triangle.svg?react';
import { styled } from '@mui/material/styles';

export const UploadManagerIcon = ({
  status,
}: {
  status: 'pending' | 'completed' | 'failed';
}) => {
  return (
    <>
      {status === 'pending' && <PendingIcon />}
      {status === 'completed' && <CheckCircleIcon />}
      {status === 'failed' && <WarningTriangleIcon />}
    </>
  );
};

const PendingIcon = styled(RefreshDoubleIcon)(({ theme }) => ({
  width: 24,
  height: 24,

  path: {
    stroke: theme.palette.white,
  },
}));
